// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HistoryOutcomeCardContext } from '../../contexts/HistoryOutcomeCardContext';
import useMergeProps from '../../hooks/useMergeProps';
import { BetslipStatus } from '../../types/betslip';
import type { VoidReason } from '../../types/history';
import { type StatusFilter } from '../../types/history';

import HistoryOutcomeCard from './HistoryItemOutcomeCard';
import legacyHistoryItemOutcomeCardSelector from './legacyHistoryItemOutcomeCardSelector';

type HistoryItemOutcomeCardContainerProps = {
  id: number;
  betslipVoidReason: VoidReason;
  statusFilter: StatusFilter;
  outcomeInfo: unknown;
  isBanker: boolean;
  odds: number;
  initialOdds?: number;
  betslipStatus: BetslipStatus;
  isSimpleBet: boolean;
  isUserPrefsCompact: boolean;
};

const HistoryItemOutcomeCardContainer = (ownProps: HistoryItemOutcomeCardContainerProps) => {
  const { betslipVoidReason, statusFilter, outcomeInfo } = ownProps;

  const selectedProps = useSelector((state) =>
    legacyHistoryItemOutcomeCardSelector(state, { betslipVoidReason, statusFilter, outcomeInfo }),
  );
  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  const { id: outcomeId, initialOdds, odds } = ownProps;

  const forwardedState = useMemo(() => ({ outcomeId, initialOdds, odds }), [initialOdds, odds, outcomeId]);

  return selectedProps ? (
    <HistoryOutcomeCardContext.Provider value={forwardedState}>
      <HistoryOutcomeCard {...enhancedProps} />
    </HistoryOutcomeCardContext.Provider>
  ) : null;
};

export default HistoryItemOutcomeCardContainer;
